import React from "react";
import { Grid } from "@mui/material";
import { Box } from "@material-ui/core";
import Button from "@components/Button";

interface Props {
  handleApprove: () => void;
  handleClose: () => void;
  secondButtonDescription: string;
  firstButtonDescription: string;
  disableSecondButton?: boolean;
  loadingSecondButton?: boolean;
}

const GroupMenuBackAndNext: React.FC<Props> = ({
  secondButtonDescription,
  firstButtonDescription,
  handleApprove,
  handleClose,
  disableSecondButton = false,
  loadingSecondButton = false,
}) => {
  return (
    <Grid container alignItems="center" justifyContent="flex-end">
      <Grid item>
        <Button
          onClick={handleClose}
          color="primary"
          fullWidth
          style={{ width: "auto", textTransform: "uppercase" }}
        >
          {firstButtonDescription}
        </Button>
      </Grid>
      <Box width={"2rem"} />

      <Grid item>
        <Button
          onClick={handleApprove}
          loading={loadingSecondButton}
          variant={"contained"}
          color="primary"
          fullWidth
          style={{ width: "auto", textTransform: "uppercase" }}
          disabled={disableSecondButton}
        >
          {secondButtonDescription}
        </Button>
      </Grid>
    </Grid>
  );
};

export default GroupMenuBackAndNext;
